// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"accordion-module--wrapper--GNMpI","list":"accordion-module--list--3MQP2","item":"accordion-module--item--1Nl3J"};